import { type Icon, Yelp } from 'react-bootstrap-icons';

import { DateParser } from '../../utils';

interface IconTitleProps {
  title: string;
  type?: 'number' | 'date' | 'text';
  value: number | string | Date | undefined;
  icon?: Icon;
  iconColor?: string;
  iconClassName?: string;
  titleClassName?: string;
}

const InformationBlock = ({
  title,
  value,
  type = 'text',
  icon: IconComponent = Yelp,
  iconColor,
  iconClassName = 'text-primary',
  titleClassName = 'text-primary'
}: IconTitleProps) => {
  const formatValue = (
    type: 'number' | 'date' | 'text',
    value: number | string | Date | undefined
  ): string => {
    if (value == null || value == undefined) {
      return '';
    }

    switch (type) {
      case 'date':
        return DateParser.toDateTimeString(new Date(value));
      case 'number':
        return Number(value).toLocaleString();

      case 'text':
        return String(value);

      default:
        return String(value);
    }
  };

  return (
    <div className="d-flex align-items-start gap-3 mt-0 mb-3">
      {IconComponent && (
        <div className="pt-1">
          <IconComponent
            size={20}
            className={iconClassName || undefined}
            style={{
              ...(iconColor != null && { color: iconColor })
            }}
          />
        </div>
      )}
      <div>
        <div className={`text-body-secondary fs-5 ${titleClassName || ''}`}>{title}</div>
        <div className="text-dark fs-1 fw-bolder"> {formatValue(type, value)} </div>
      </div>
    </div>
  );
};

export { InformationBlock };
